/**
 * lazy.js handles lazy loading for imgs, videos and iframes.
 * It looks for wrappers with class 'lazy' and then lazy loads the content.
 * Example usage:
 *  <div class="lazy">
 *    <img data-src="images/test.jpg"/>
 *  </div>
 */
import $ from 'jquery';
import inView from 'in-view';

function init() {
  appendLazyLoaders();

  inView('.lazy')
    .on('enter', handleLazy);
}

function handleLazy(el) {
  const $el = $(el);

  if ($el.hasClass('lazy-loaded')) {
    return false;
  }

  const img = $el.find('img');
  const video = $el.find('video');
  const iframe = $el.find('iframe');

  // set src with data-src attr
  if (img.length) {
    img.attr('src', img.attr('data-src'));
  } else if (video.length) {
    video.attr('poster', video.attr('data-poster'));
    let sources = video.find('source');
    sources.each((i, source) => {
      const $source = $(source);
      $source.attr('src', $source.attr('data-src'));
    });
    video[0].load();
  } else if (iframe.length) {
    iframe.attr('src', iframe.attr('data-src'));
  }

  $el.addClass('lazy-loaded');
  $el.find('.lazyloader').remove();
}

function appendLazyLoaders(){
  $('.lazy').prepend(`
    <div class="lazyloader">
      <svg class="icon icon-loading spin">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#loading"></use>
      </svg>
    </div>`
  );
}

export default {
  init
};
